import { regionDataSchema, type RegionDataType } from '@/schemas/regionDataSchema';
import { CustomError } from '@/utils/errors';
import logger from '@/app/logger';
import axios, { isAxiosError } from 'axios';
import type config from '@/config';

export const regionDataQuery_Client = async (region: string): Promise<RegionDataType> => {
  const url = `/api/region/${region}`;
  logger.info(`Fetching region data: ${url}...`);
  return axios
    .get(url)
    .then((res) => {
      logger.info('Region: Got response');
      if (!res.data) {
        throw new CustomError('No agency data found for the region: ' + region, 404);
      }
      return regionDataSchema.parse(res.data);
    })
    .catch((error: unknown) => {
      if (isAxiosError(error) && error.response?.status === 404) {
        throw new CustomError('Can not find region ' + region, 404, 'agency' as keyof typeof config.PAGE_NAMES);
      }
      logger.info('Region: Got error:', error);
      return Promise.reject(error);
    });
};
